import { createFileRoute } from "@tanstack/react-router";

import { AdminPage } from "../features/admin/AdminPage";
import { useMe } from "../features/auth/session";
import { useT } from "../i18n/I18nProvider";

export const Route = createFileRoute("/app/admin/")({
  component: OrganizationsRoute,
});

function OrganizationsRoute() {
  const t = useT();
  const me = useMe();
  if (!me.data) return <p>{t("common.loading")}</p>;
  return <AdminPage key={me.data.user.id} me={me.data} />;
}
